import { useMutation } from '@tanstack/react-query'
import { useAPI } from '../../../Contexts/APIContext'

export const useManageOrganizationGroupContent = () => {
  const { manageOrganizationGroupContent } = useAPI()

  return useMutation({
    mutationFn: data =>
      manageOrganizationGroupContent({
        ...data,
      }),
  })
}
